import { Outlet } from "react-router-dom";
import styled from "styled-components";
import {
  DivContent,
  DivMain,
  DivNavigation,
} from "components/layout/style/layout_common.style";
import { Toaster } from "react-hot-toast";
import AdmMenu from "./AdmMenu";
import { useAuthCurrent } from "hooks/auth/auth_current";

export default function AdminLayout() {
  return (
    <DivMain>
      <DivNavigation>
        <AdmMenu />
      </DivNavigation>

      <Toaster />

      <DivContent>
        <Outlet />
      </DivContent>
    </DivMain>
  );
}

const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
`;

const FullWidth = styled.div`
  width: 100%;
`;
